import {
  deleteProviderEstimate,
  fetchProviderEstimates,
} from "@/api/providerDashboard";

export default {
  resolveActiveTab(route) {
    const routeTab = route && route.query && route.query.tab;
    return routeTab === "response" ? "response" : "request";
  },
  resolveDateRange(route) {
    const query = (route && route.query) || {};
    const startDate = query.startDate || "";
    const endDate = query.endDate || "";
    return startDate && endDate ? [startDate, endDate] : [];
  },
  resolvePage(route) {
    const page = Number(route && route.query && route.query.page);
    return Number.isInteger(page) && page > 0 ? page : 1;
  },
  async updateRouteQuery({ page = this.page } = {}) {
    const routeQuery = (this.$route && this.$route.query) || {};
    const query = {
      ...routeQuery,
      tab: this.activeTab,
      page: String(page),
    };

    const dateRange = Array.isArray(this.dateRange) ? this.dateRange : [];
    if (dateRange.length === 2) {
      query.startDate = dateRange[0];
      query.endDate = dateRange[1];
    } else {
      delete query.startDate;
      delete query.endDate;
    }

    if (
      Object.keys(query).some((key) => String(routeQuery[key] || "") !== String(query[key] || "")) ||
      Object.keys(routeQuery).some((key) => !(key in query))
    ) {
      await this.$router.replace({
        path: this.$route.path,
        query,
      });
    }
  },
  async handleTabClick() {
    this.page = 1;
    await this.updateRouteQuery();
    await this.loadEstimates();
  },
  async handleDateRangeChange(value) {
    this.dateRange = value && value.length === 2 ? value : [];
    this.page = 1;
    await this.updateRouteQuery();
    await this.loadEstimates();
  },
  async handlePageChange(page) {
    this.page = page;
    await this.updateRouteQuery();
    await this.loadEstimates();
  },
  async loadEstimates() {
    const requestId = ++this.estimateLoadRequestId;

    try {
      const params = {
        status: this.activeTab,
        page: this.page,
        limit: this.pageSize,
      };
      const dateRange = Array.isArray(this.dateRange) ? this.dateRange : [];
      if (dateRange.length === 2) {
        params.startDate = dateRange[0];
        params.endDate = dateRange[1];
      }
      const res = await fetchProviderEstimates({
        ...params,
      });
      if (res.data.status !== 200) {
        throw new Error(res.data.message || "견적 목록을 불러오지 못했습니다.");
      }
      if (requestId !== this.estimateLoadRequestId) return false;

      this.estimates = res.data.data;
      this.total = Number(res.data.total) || 0;
      const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize));
      if (this.page > maxPage) {
        this.page = maxPage;
        await this.updateRouteQuery();
        return this.loadEstimates();
      }
      return true;
    } catch (err) {
      console.error(err);
      if (requestId === this.estimateLoadRequestId) {
        this.estimates = [];
        this.total = 0;
        this.$message.error("견적 목록을 불러오지 못했습니다.");
      }
    }
    return false;
  },
  async handleDeleteEstimate(estimateId) {
    if (this.deletingEstimateId !== null) return;
    this.deletingEstimateId = estimateId;

    try {
      await this.$confirm(
        "이 견적을 목록에서 삭제하시겠습니까? 고객의 견적과 회신 내역은 유지됩니다.",
        {
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          type: "warning",
        }
      );
    } catch (error) {
      this.deletingEstimateId = null;
      return;
    }

    try {
      const response = await deleteProviderEstimate(estimateId);
      if (response.data && response.data.status !== undefined && response.data.status !== 200) {
        throw new Error(response.data.message || "견적 삭제에 실패했습니다.");
      }
      this.$message.success("견적이 삭제되었습니다.");
      await this.loadEstimates();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        "견적 삭제에 실패했습니다.";
      await this.$alert(message, { confirmButtonText: "확인" });
    } finally {
      this.deletingEstimateId = null;
    }
  },
};
